import { supplierDefs } from '@purchase/supplier';

/** 关联供应商卡片（DTO 仅 vendorId/vendorName，后端实际返回富字段，此处本地扩展） */
export interface RelatedVendorCard {
  vendorId?: string;
  vendorName?: string;
  desc?: string;
  tagId?: string | number;
  tagLevel?: string | number;
  tags?: { label?: string; tagLevel?: string | number }[];
}

/** 事故详情数据（DTO 缺 demandNames / relatedVendors 富字段 / responsibleServiceTypeName / remark，此处本地扩展） */
export type AccidentDetailData = supplierDefs.AccidentDetailDto & {
  demandNames?: string[];
  relatedVendors?: RelatedVendorCard[];
  responsibleServiceTypeName?: string;
  remark?: string;
};

/**
 * 服务类型 Tag（责任服务类型/关联服务类型）样式：对齐「查看流程」（@purchase/oaflow）页 tag 观感。
 * 走 Tailwind（含 CSS 变量任意值）：height 24px、padding 3px 7px、text-sm、
 * border-radius var(--border-radius-base-inside)、min-width 40px、灰底 fill-1 / 灰字 text-color-2。
 * 不设 max-width / ellipsis——文字完整展示；多标签换行由父级 flex flex-wrap gap-1 容器负责
 * （裸 span 会继承 FormDescriptions 单元格 nowrap，导致截断且不换行）。
 */
export const SERVICE_TAG_CLASSNAME =
  'inline-flex items-center justify-center box-border h-6 px-[7px] py-[3px] text-sm rounded-[var(--border-radius-base-inside)] min-w-[40px] whitespace-nowrap text-[color:var(--text-color-2)] bg-[var(--fill-1)]';

/** tagLevel → 关联供应商卡片标签配色（1/2 红、3/4 橙，对齐 Figma 设计稿） */
export const VENDOR_TAG_COLOR: Record<string, { bg: string; color: string }> = {
  '1': { bg: '#ffebe6', color: '#e55140' },
  '2': { bg: '#ffebe6', color: '#e55140' },
  '3': { bg: '#fff6e5', color: '#e08216' },
  '4': { bg: '#fff6e5', color: '#e08216' },
};

/** 事故等级 → Tag 内联样式（精确 hex，对齐设计稿） */
export const LEVEL_TAG_STYLE: Record<string, React.CSSProperties> = {
  P0: { background: '#ffebe6', color: '#e55140' },
  P1: { background: '#FFF6E5', color: '#e08216' },
  P2: { background: '#E0F1FF', color: '#1e40af' },
  P3: { background: '#f5f5f5', color: '#666666' },
};
